import { AnyAction } from 'redux';
import { Actions, IResponseAuth } from '../../Actions/Session/Types';
import { IAccount } from '../../Models/Account';

export enum EStatusRequest {
	PENDING,
	PROCESS,
	COMPLETE,
	FAIL
}

export interface ISessionState {
	token?: string;
	isChecking: boolean;
	isAuthorize: boolean;
	message?: string;
	alert?: string;
	account?: IAccount;
	status: EStatusRequest;
	error?: any;
}

const initialState = {
	token: undefined,
	isAuthorize: false,
	isChecking: false,
	status: EStatusRequest.PENDING
};

const asyncReducer = (
	state: ISessionState = initialState,
	action: AnyAction
) => {
	switch (action.type) {
		case Actions.STATUS_SESSION:
			return {...state, status: action.payload };
		case Actions.ERROR_SESSION:
			return {...state, error: action.payload }
		case Actions.CHECKING_TOKEN:
				return {...state,  isChecking: true };
		case Actions.REQUEST_TOKEN:
			return {...state,  isChecking: true };
		case Actions.CHECKED_TOKEN:
		case Actions.RESPONSE_TOKEN:
			const responseAuth = action.payload as IResponseAuth;
			return {...state,
				isChecking: false,
				isAuthorize: responseAuth.isAuth,
				token: responseAuth.token,
				message: responseAuth.message
			};
		case Actions.INIT_SESSION:
			const account = action.payload;
			return {...state,
				account
			};
		case Actions.FETCH_FAENAS:
			const faenas = action.payload;
			return {...state, faenas };
	}
	return state;
};

export default asyncReducer;
